import { Box, Stack, Typography } from '@mui/material';
import { CircleCheck, CircleDashed } from 'lucide-react';
import { CopyToClipboardButton } from 'src/components/CopyToClipboardButton/copy-to-clipboard-button';
import { splitHostname } from './cg-custom-domain-display';
import { inlineIconSx, mutedSx, recordLabelSx, recordTypeSx, recordValueSx } from './styles';

interface CgCustomDomainRecordProps {
  hostname: string;
  cnameTarget: string;
  isFound: boolean;
}

export const CgCustomDomainRecord = ({
  hostname,
  cnameTarget,
  isFound,
}: CgCustomDomainRecordProps) => {
  const { label, apex } = splitHostname(hostname);

  return (
    <Stack direction="row" spacing={1.5}>
      <Box component="span" sx={recordTypeSx}>
        CNAME
      </Box>

      <Stack spacing={0.5} sx={{ minWidth: 0, flex: 1 }}>
        <Stack direction="row" alignItems="center" spacing={1}>
          <Typography variant="caption" sx={recordLabelSx}>
            Name
          </Typography>
          <Typography component="code" sx={recordValueSx}>
            <b>{label}</b>
            <Box component="span" sx={mutedSx}>
              .{apex}
            </Box>
          </Typography>
          <CopyToClipboardButton
            content={label}
            tooltipText="Copy name"
            successMessage="Copied"
          />
        </Stack>

        <Stack direction="row" alignItems="center" spacing={1}>
          <Typography variant="caption" sx={recordLabelSx}>
            Value
          </Typography>
          <Typography component="code" sx={recordValueSx}>
            {cnameTarget}
          </Typography>
          <CopyToClipboardButton
            content={cnameTarget}
            tooltipText="Copy value"
            successMessage="Copied"
          />
        </Stack>

        <Typography
          variant="body2"
          sx={{
            ...inlineIconSx,
            color: isFound ? 'success.main' : 'custom.OV.sys.onSurfaceVariant',
          }}
        >
          {isFound ? <CircleCheck /> : <CircleDashed />}
          {isFound ? 'Found' : 'Not found yet'}
        </Typography>
      </Stack>
    </Stack>
  );
};
